import EBarNewsCTA from './EBarNewsCTA';

export default EBarNewsCTA;
